import Vue from 'vue'
import Router from 'vue-router'
import HomePagePC from "../views/homePC.vue"; //首页
import HomePageH5 from "../views/homeH5.vue"; //首页

Vue.use(Router)

const constantRoutes = [
  {
    path: "/", //pc主页
    component: HomePagePC
  },
  {
    path: '/h5', //h5官网
    component: HomePageH5,
  }
]
let router = new Router({
  mode: 'history',
  //路由变化时回到顶部
  scrollBehavior: () => {
    // return to.meta || 0;
    return {x: 0, y: 0};
  },
  routes: constantRoutes
})
export default router